import { Document, Page, StyleSheet } from "@react-pdf/renderer";
import React from "react";
import AssoiciatedTableData from "../PDFComponents/AssoiciatedTableData";
import AssoiciatedTableHeader from "../PDFComponents/AssoiciatedTableHeader";
import CarTableData from "../PDFComponents/CarTableData";
import CarTableHeader from "../PDFComponents/CarTableHeader";
import Comments from "../PDFComponents/Comments";
import DetailHeader from "../PDFComponents/DetailHeader";
import EmployeeDetailList from "../PDFComponents/EmployeeDetailList";
import FlightTableData from "../PDFComponents/FlightTableData";
import FlightTableHeader from "../PDFComponents/FlightTableHeader";
import History from "../PDFComponents/History";
import HotelTableData from "../PDFComponents/HotelTableData";
import HotelTableHeader from "../PDFComponents/HotelTableHeader";
import MainHeader from "../PDFComponents/MainHeader";
import OtherTableData from "../PDFComponents/OtherTableData";
import OtherTableHeader from "../PDFComponents/OtherTableHeader";
import PlainHeader from "../PDFComponents/PlainHeader";
import TripDetailsList from "../PDFComponents/TripDetailsList";
import LogoFooter from "../PDFComponents/LogoFooter";

const TripsOne = ({ data, tripsHistory, CommentsData }) => {
  const styles = StyleSheet.create({
    page: {
      paddingTop: 60,
      paddingLeft: 40,
      paddingRight: 40,
      lineHeight: 1.5,
      flexDirection: "column",
    },
  });

  return (
    <Document>
      <Page size="A4" style={styles.page} wrap={false}>
        <MainHeader data={data} />
        <DetailHeader title="Employee Details" />
        <EmployeeDetailList data={data} />
        <DetailHeader title="Trip Details" />
        <TripDetailsList data={data} />
        <DetailHeader title="Travel Summary" />
        <PlainHeader title="Flight Reservations" />
        <FlightTableHeader />
        <FlightTableData data={data} />
        <PlainHeader title="Hotel Reservations" />
        <HotelTableHeader />
        <HotelTableData data={data} />
        <PlainHeader title="Car Rentals" />
        <CarTableHeader />
        <CarTableData data={data} />
        <PlainHeader title="Other" />
        <OtherTableHeader />
        <OtherTableData data={data} />
        <PlainHeader title="Assoiciated Report" />
        <AssoiciatedTableHeader />
        <AssoiciatedTableData data={data} />
        <DetailHeader title="Comments" />
        <Comments data={CommentsData} />
        <DetailHeader title="History" />
        <History data={tripsHistory} />
        <LogoFooter />
      </Page>
    </Document>
  );
};

export default TripsOne;
